<template lang="pug">
    fragment
        // Arrow
        td
            expand-component(:class="{'expanded' : expanded}")

        // First Name
        td
            div.fullName {{ item.fullName }}

        // Status
        td
            status-component.primaryColor(v-if="item.isActive")
            status-component.warningColor(v-else )

        // Role
        td
            div.role {{ managerRole(item.role) }}

        // Actions
        td.px-0.text-xs-right

            // Edit manager button
            button-component(:action="edit" color="primary" icon="edit")

            // Delete manager button
            button-component(:action="deleteManager" color="primary" icon="delete")
</template>

<script>
    import VueTypes from 'vue-types';
    import ButtonIcon from '~components/ButtonIcon';
    import ExpandIcon from '~components/ExpandIcon';
    import Status from '~components/Status';
    import { mapActions } from 'vuex';

    export default {
        components: {
            ExpandComponent: ExpandIcon,
            ButtonComponent: ButtonIcon,
            StatusComponent: Status
        },
        props: {
            item: VueTypes.object.def({}),
            expanded: VueTypes.bool.def(false)
        },
        methods: {
            ...mapActions('managers', ['deleteAccount']),

            managerRole(role) {
                return role === 'instructor' ? 'I' : 'A';
            },

            /**
             * Edit manager
             */
            edit() {
                this.$router.push({
                    name: 'dashboard.managers.edit',
                    params: { id: this.item.id }
                });
            },

            async deleteManager() {
                const resp = await this.deleteAccount(this.item.id);

                if (resp) {
                    this.$emit('removed', this.item.id);
                }
            }
        }
    };
</script>

<style lang="stylus" scoped>
    @import "../../../../assets/style/_variables.styl"

    .fullName
        max-width: 140px
        overflow: hidden
        text-overflow: ellipsis
</style>
